<template>
  <div>
    <p>
      Are you sure you want to delete <strong>{{ story.title }}</strong>?
    </p>
    <small>
      If you're sure, type <strong>{{ story.title }}</strong> into the text input below.
    </small>
    <input
      v-model="confirmDelete"
      class="input mt-15"
      type="text"
      :placeholder="story.title"
    >
    <button
      v-if="confirmDelete == story.title"
      class="button is-danger mt-15"
      @click="deleteStory"
    >
      Delete Story
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DeleteStory',
  props: {
    story: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDelete: '',
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
  },
  methods: {
    deleteStory() {
      const method = 'DELETE';
      const url = `${this.API}/stories/${this.story.id}`;
      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            location.reload(true);
            this.$snotify.success('Deleted Successfully','Success');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(err, 'Deleting failed', {
            timeout: 10000,
            showProgressBar: false,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
label {
  text-align: left;
}
select {
  background-image: none;
}
</style>
